import { Form, Row, Col, Button, Popconfirm } from "antd";
import { useTranslation } from "react-i18next";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";
import { PlusOutlined } from "@ant-design/icons";
import { X, Edit2, ArrowUp, ArrowDown } from "react-feather";
import AdnInput from "../common/adnInput/AdnInput";
import { QuizStatus } from "../common/GeneralConfigurations";
import AdnCard from "../common/adnCard/AdnCard";
import "./QuizBuilderForm.css";

const GroupForm = ({
  isSubGroup = false,
  groupQuiz,
  groupNameValidation,
  groupNoteValidation,
  handleMoveUp,
  handleMoveDown,
  handleDeleteGroup,
  handleCancelGroup,
  handleGroupName,
  handleGroupNote,
  handleGroupMaxAnswer,
  handleGroupMinAnswer,
  groupForm,
  handleSaveGroup,
  showGroupButtons,
  quizGroupQuestions,
  quizSubGroup,
  handleAddQuestion,
  handleAddSubgroup,
  groups,
  isFirstSubgroup,
  isLastSubgroup,
  quiz,
  setEditGroup,
  editGroup,
}) => {
  const { t } = useTranslation();

  const isFirstGroup = groups.findIndex((g) => g.id === groupQuiz.id) === 0;
  const isLastGroup =
    groups.findIndex((g) => g.id === groupQuiz.id) === groups.length - 1;

  const genExtra = (event) => (
    <Row gutter={16}>
      {showGroupButtons && quiz.status !== QuizStatus.Published && (
        <Col>
          {!isFirstSubgroup && !isFirstGroup && (
            <Popconfirm
              title={t("groupForm.confirmations.changeGroupOrder")}
              onConfirm={() => handleMoveUp(event)}
            >
              <Button
                size="small"
                className="group-updownbutton"
                title={t("groupForm.buttons.moveUp")}
              >
                <ArrowUp />
              </Button>
            </Popconfirm>
          )}
          {!isLastSubgroup && !isLastGroup && (
            <Popconfirm
              title={t("groupForm.confirmations.changeGroupOrder")}
              onConfirm={() => handleMoveDown(event)}
            >
              <Button
                size="small"
                className="group-updownbutton"
                title={t("groupForm.buttons.moveDown")}
              >
                <ArrowDown />
              </Button>
            </Popconfirm>
          )}
          <Popconfirm
            title={t("groupForm.confirmations.deleteGroup")}
            onConfirm={() => handleDeleteGroup(event)}
          >
            <Button
              type="link"
              danger
              size="small"
              title={t("groupForm.buttons.delete")}
            >
              <X />
            </Button>
          </Popconfirm>
        </Col>
      )}
    </Row>
  );
  const handleExpandClick = () => {
    setEditGroup(true);
  };

  return (
    <>
      <AdnCard>
        <div className={!isSubGroup ? "new-group" : "subgroup"}>
          {editGroup ? (
            <Form
              form={groupForm}
              name="groupForm"
              layout="vertical"
              onFinish={handleSaveGroup}
              initialValues={groupQuiz || []}
            >
              <Row className="gutter-row">
                <AdnInput name="id" type="hidden" defaultValue={groupQuiz.id} />
                <Col span={24}>
                  <AdnTextArea
                    name="name"
                    type="text"
                    placeholder={t("groupForm.placeholders.newGroupName")}
                    label={t("groupForm.labels.groupName")}
                    maxLength={200}
                    defaultValue={groupQuiz && groupQuiz.name}
                    handleChange={handleGroupName}
                    rules={groupNameValidation}
                    disabled={quiz.status === QuizStatus.Published}
                    autoSize
                  />
                </Col>
              </Row>

              <Row className="gutter-row">
                <Col span={24}>
                  <AdnInput
                    name="note"
                    label={t("groupForm.labels.note")}
                    placeholder={t("groupForm.placeholders.groupNote")}
                    maxLength={250}
                    rules={groupNoteValidation}
                    showCount={true}
                    defaultValue={groupQuiz && groupQuiz.note}
                    handleChange={handleGroupNote}
                    disabled={quiz.status === QuizStatus.Published}
                  />
                </Col>
              </Row>

              <Row className="gutter-row">
                <Col span={24}>
                  <Row gutter={16}>
                    <Col>
                      <AdnInput
                        name="minAnswers"
                        min={1}
                        max={99}
                        type="number"
                        label={t("groupForm.labels.minimumAnswers")}
                        placeholder={t("groupForm.placeholders.minimumAnswers")}
                        defaultValue={groupQuiz && groupQuiz.minAnswers}
                        handleChange={handleGroupMinAnswer}
                        disabled={quiz.status === QuizStatus.Published}
                      />
                    </Col>
                    <Col>
                      <AdnInput
                        name="maxAnswers"
                        min={1}
                        max={99}
                        type="number"
                        label={t("groupForm.labels.maximumAnswers")}
                        placeholder={t("groupForm.placeholders.maximumAnswers")}
                        defaultValue={groupQuiz && groupQuiz.maxAnswers}
                        handleChange={handleGroupMaxAnswer}
                        disabled={quiz.status === QuizStatus.Published}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              {quiz.status !== QuizStatus.Published && (
                <Row className="gutter-row" gutter={16}>
                  <Col xs={24}>
                    <Row gutter={16} justify="end">
                      <Col>
                        <Popconfirm
                          title={t("groupForm.confirmations.cancelChanges")}
                          onConfirm={() => handleCancelGroup(groupQuiz)}
                          okText={t("groupForm.buttonsText.yes")}
                          cancelText={t("groupForm.buttonsText.no")}
                        >
                          <Button className="adn-outlined-button outlined-cancel">
                            {t("groupForm.buttons.cancel")}
                          </Button>
                        </Popconfirm>
                      </Col>
                      <Col>
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="adn-primary-button"
                        >
                          {t("groupForm.buttons.saveAndClose")}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Form>
          ) : (
            <>
              {groupQuiz.id && (
                <Row style={{ width: "100%" }}>
                  <Col xs={24}>
                    {/*Group details*/}
                    <Row
                      justify="space-between"
                      style={{ marginBottom: "1rem" }}
                    >
                      <Col xs={24} sm={24} md={24} lg={20} xl={20} xxl={20}>
                        <Row align="middle" gutter={12}>
                          <Col xs={24} className="group-title">
                            <AdnTextArea
                              name="name"
                              type="text"
                              placeholder={
                                groupQuiz.description
                                  ? groupQuiz.description
                                  : groupQuiz.name
                              }
                              disabled
                              autoSize
                            />
                          </Col>
                          {groupQuiz.maxAnswers && groupQuiz.minAnswers && (
                            <Col>
                              <p
                                style={{
                                  margin: 0,
                                  color: "var(--adngrey)",
                                  fontWeight: "bold",
                                }}
                              >
                                {t("groupForm.display.max")}:&nbsp;
                                {groupQuiz.maxAnswers}
                                &nbsp;|&nbsp;{t("groupForm.display.min")}:&nbsp;
                                {groupQuiz.minAnswers}
                              </p>
                            </Col>
                          )}
                        </Row>
                        <p style={{ margin: 0, padding: 0 }}>
                          {groupQuiz.note}
                        </p>
                      </Col>
                      {quiz.status !== QuizStatus.Published && (
                        <Col xs={24} sm={24} md={24} lg={4} xl={4} xxl={4}>
                          <Row gutter={12} justify="end">
                            <Col>
                              <Edit2
                                onClick={handleExpandClick}
                                color="var(--adnblue)"
                              />
                            </Col>
                            <Col>{genExtra(groupQuiz)}</Col>
                          </Row>
                        </Col>
                      )}
                    </Row>

                    {/*Group elements*/}
                    <Row style={{ width: "100%" }}>
                      <Col xs={24}>
                        {quizSubGroup.length > 0 && (
                          <>
                            <h6>{t("groupForm.labels.subgroups")}</h6>
                            <Row style={{ width: "100%" }}>
                              <Col span={24}>{quizSubGroup}</Col>
                            </Row>
                          </>
                        )}
                      </Col>
                      <Col xs={24}>
                        {quizGroupQuestions.length > 0 && (
                          <>
                            <h6>{t("groupForm.labels.questions")}</h6>
                            <Row style={{ width: "100%" }}>
                              <Col span={24}>{quizGroupQuestions}</Col>
                            </Row>
                          </>
                        )}
                      </Col>
                    </Row>

                    {/*Group buttons*/}
                    {showGroupButtons &&
                      quiz.status !== QuizStatus.Published && (
                        <Row gutter={12} justify="end">
                          {quizSubGroup.length === 0 && (
                            <Col>
                              <Button
                                className="adn-primary-button"
                                onClick={handleAddQuestion}
                              >
                                {t("groupForm.buttons.addQuestion")}{" "}
                                <PlusOutlined />
                              </Button>
                            </Col>
                          )}
                          {isSubGroup === false &&
                            quizGroupQuestions.length === 0 && (
                              <Col>
                                <Button
                                  className="adn-primary-button"
                                  onClick={() =>
                                    handleAddSubgroup(groupQuiz.id)
                                  }
                                >
                                  {t("groupForm.buttons.addSubgroup")}
                                  <PlusOutlined />
                                </Button>
                              </Col>
                            )}
                        </Row>
                      )}
                  </Col>
                </Row>
              )}
            </>
          )}
        </div>
      </AdnCard>
    </>
  );
};

export default GroupForm;
